let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("ffQaD"), load("kvRbA"), load("lyxWA")]).then(() => parcelRequire('dEmav'));